import type BigNumber from 'bignumber.js';

import { numberToString } from '../../../utils/Numbers';

export function formatTotalBalance(
  showTotalBalance: boolean,
  sumWalletInUsd: string | number | BigNumber,
): string {
  if (!showTotalBalance) {
    return '******';
  }
  if (Number(sumWalletInUsd) > 0) {
    return `$${numberToString(sumWalletInUsd.toString())}`;
  }
  return '$0';
}
